<template>
  <div id="top" class="browse page" :class="currentTastingDeets.tastingSize">
    <TastingHeader v-bind:tastingInfo="currentTastingDeets" />

    <div class="container browse_content_area">
      <div class="spacer"></div>
      <!--<div v-if="currentTastingDeets.tastingSize == 'small'">
        <div class="form-row">
          <div class="col-8">
            <input type="text" class="form-control" placeholder="Search All Items  ..." v-model="search" @keyup.enter="searchSkus" />
          </div>
          <div class="col-4">
            <button type="submit" class="btn btn-primary btn-fw" @click="searchSkus">Search</button>
          </div>
        </div>
      </div>-->
      <div v-if="showLoading" class="showLoading">
        <h2>Refreshing Tasting Data</h2>
        <div class="sk-chase">
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
          <div class="sk-chase-dot"></div>
        </div>
      </div>
      <div v-else-if="loadingError" class="showLoading">
        <h2>Something Went Wrong</h2>
        <p class="loading-error-msg">{{ loadingError }}</p>
        <button class="btn btn-primary" @click="retryLoad">Try Again</button>
      </div>
      <div v-else>
        <div v-if="haveFilteredResults">
          <div class="search_bar" v-if="resultFilters">
            Current Filters: <strong v-html="resultFilters"></strong>&nbsp;
            <button class="btn btn-secondary" @click="clearFilter">Clear</button>
          </div>
          <Tables v-bind:tables="resultTables" v-bind:alldata="alldata" />
        </div>
        <div v-else>
          <div class="search_bar" style="display: none">
            <button class="btn btn-secondary btn-fw" @click="searchFilter">Filter Tables</button>
          </div>
          <Tables v-bind:tables="alldata.tables" v-bind:alldata="alldata" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Tables from '@/components/Tables.vue';

import TastingHeader from '@/components/TastingHeader.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Browse',
  components: {
    Tables,

    TastingHeader,
  },

  data() {
    return {
      //resultTables: [],

      search: '',
    };
  },
  methods: {
    ...mapActions(['fetchAlldata', 'fetchUser', 'setTablesExpandedVu', 'setTableOpen', 'setTablesClosed', 'setShowLoading']),
    searchFilter() {
      //this.$store.commit('hideIntro');
      this.$router.push({ name: 'NewSearch' });
    },
    clearFilter() {
      this.$store.dispatch('setResultTables', []);
      this.$store.dispatch('setResultFilters', false);
      this.$store.dispatch('setResultCount', false);
      this.$router.push({ name: 'Browse' });
    },
    retryLoad() {
      this.$store.commit('setLoadingError', null);
      this.setShowLoading(true);
      localStorage.removeItem('alldata');
      this.fetchAlldata();
    },
    searchSkus() {
      //alert(this.search);
      //this.$store.dispatch('searchSkus', []);
      this.$router.push({ name: 'Results', params: { search: this.search } });
    },
    scrollToTable(tableNumber) {
      // Wait for data to load, then scroll to the table
      // The table elements have id="tb{tableNumber}" (e.g., "tb5" for table 5)
      const targetId = 'tb' + tableNumber;
      const tableNum = parseInt(tableNumber);
      let attempts = 0;
      const maxAttempts = 400; // Try for up to 80 seconds (400 * 200ms)

      const tryScroll = () => {
        const tableElement = document.getElementById(targetId);
        if (tableElement) {
          // 1. First collapse all tables
          this.setTablesClosed();

          // 2. Then open just the target table
          this.setTableOpen(tableNum);

          // 3. Wait a moment for Vue to re-render, then scroll and highlight
          this.$nextTick(() => {
            setTimeout(() => {
              tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              // Add highlight effect
              tableElement.classList.add('highlight-flash');
              setTimeout(() => {
                tableElement.classList.remove('highlight-flash');
              }, 2000);
            }, 100);
          });
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(tryScroll, 200);
        }
      };

      // Start trying after a short delay to allow initial render
      setTimeout(tryScroll, 300);
    },
  },
  computed: {
    ...mapGetters([
      'alldata',
      'user',
      'currentTasting',
      'currentTastingDeets',
      'resultTables',
      'resultFilters',
      'getTablesExpandedVu',
      'showLoading',
      'loadingError',
    ]),
    u() {
      return this.$store.getters.user;
    },
    haveFilteredResults() {
      if (this.resultTables != null) {
        if (typeof this.resultTables != 'undefined') {
          if (Object.keys(this.resultTables).length >= 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
      return false;
    },
  },
  created() {
    this.setShowLoading(true);
    this.fetchAlldata();
    this.fetchUser();
  },
  mounted() {
    // Check for QR code scroll-to-table directive
    const scrollToTable = localStorage.getItem('qr_scroll_to_table');
    if (scrollToTable) {
      localStorage.removeItem('qr_scroll_to_table');
      // Clear any active search filters so all tables are visible
      this.$store.dispatch('setResultTables', []);
      this.$store.dispatch('setResultFilters', false);
      this.$store.dispatch('setResultCount', false);
      this.$nextTick(() => {
        this.scrollToTable(scrollToTable);
      });
    }

    // Existing hash-based scroll functionality
    const isHash = window.location.hash ? window.location.hash.split('#') : undefined;
    if (isHash) {
      //console.log (isHash[1]+' OK')
      let tmp = setTimeout(() => {
        if (document.getElementById(isHash[1]) != null) {
          document.getElementById(isHash[1]).scrollIntoView();

          clearTimeout(tmp);
        } else {
          console.log('target not found' + window.location.hash);
        }
      }, 400);
      //setTimeout(function() {window.scrollTo(0, number);}, 1000)
    }
  },
};
</script>
